import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { responsiveCssProperties } from '../../utils';
import { Box } from '../Box';
import './Flex.css';
/**
 * Lay out your components by using the [Flexbox Layout module](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout/Basic_Concepts_of_Flexbox).
 *
 * Inherits all properties from the `<Box>` component.
 */
export const Flex = forwardRef(function Flex(props, ref) {
    const { elementType = 'div', className, direction, alignItems, alignContent, justifyContent, gap, rowGap, columnGap, wrap, style, ...rest } = props;
    return (React.createElement(Box, { ...rest, elementType: elementType, className: clsx('mollie-ui-flex', className), style: {
            ...style,
            ...responsiveCssProperties({
                '--mollie-ui-flex-row-gap': rowGap !== null && rowGap !== void 0 ? rowGap : gap,
                '--mollie-ui-flex-column-gap': columnGap !== null && columnGap !== void 0 ? columnGap : gap,
                '--mollie-ui-flex-direction': direction,
                '--mollie-ui-flex-wrap': wrap ? 'wrap' : undefined,
                '--mollie-ui-flex-align-items': alignItems,
                '--mollie-ui-flex-align-content': alignContent,
                '--mollie-ui-flex-justify-content': justifyContent,
            }),
        }, ref: ref }));
});
Flex.displayName = 'Flex';
//# sourceMappingURL=Flex.js.map